// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop() { }
